import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { enableAllUsersInAccount, getDealers , disableAllUsersInAccount, disableUser, enableUser } from './actions'
import App from '../common/app'
import Dealers from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="admin" {...getState()} {...appActions}>
      <Dealers {...getState()} 
      onEnableAllUsers={enableAllUsersInAccount} 
      onDisableAllUsers={disableAllUsersInAccount}  
      onDisableUser={disableUser} 
      onEnableUser={enableUser} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getDealers()
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
